import {MetaData} from '../../api/interfaces/metadata';

export function visibleMetadata(metadata: MetaData[] | undefined | null): MetaData[] {
  return (metadata || []).filter(meta => meta.type !== 'system');
}

export function systemMetadata(metadata: MetaData[] | undefined | null): MetaData[] {
  return (metadata || []).filter(meta => meta.type === 'system');
}
